module.exports = __webpack_public_path__ + "static/media/8.2520f1a5.svg";